import { makeStyles } from 'tss-react/mui';

export const useUserMenuButtonStyles = makeStyles()((theme) => ({
  root: {
    color: theme.palette.text.primary,
    '& .MuiButton-endIcon': {
      color: theme.palette.text.secondary,
    },
    '&:hover .MuiButton-endIcon': {
      color: theme.palette.text.primary,
    },
    maxWidth: 225,
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    paddingInline: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      border: `1px solid ${theme.palette.custom.border.primary}`,
      width: '100%',
      maxWidth: 'unset',
    },
  },
}));
